export class InputFieldHelper {
    static isValidRegEx(regEx: string): boolean {
        try {
            new RegExp(regEx);
            return true;
        } catch (error) {
            return false;
        }
    }

    static isValidDate(dateString: string | Date): boolean {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
    }

    static toLocalDateString(dateString?: string | Date): string {
        if (!dateString || !InputFieldHelper.isValidDate(dateString)) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString();
    }

    static toLocalDateTimeString(dateString?: string | Date): string {
        if (!dateString || !InputFieldHelper.isValidDate(dateString)) return '';
    
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
    
        return date.toLocaleString(undefined, options);
    }
    
    static toDate(dateString?: string): string {
        if (!dateString || !InputFieldHelper.isValidDate(dateString)) return '';

        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    static toDateTime(dateTimeString?: string): string {
        if (!dateTimeString || !InputFieldHelper.isValidDate(dateTimeString)) return '';

        const dateTime = new Date(dateTimeString);
        const year = dateTime.getFullYear();
        const month = ('0' + (dateTime.getMonth() + 1)).slice(-2);
        const day = ('0' + dateTime.getDate()).slice(-2);
        const hours = ('0' + dateTime.getHours()).slice(-2);
        const minutes = ('0' + dateTime.getMinutes()).slice(-2);
        const seconds = ('0' + dateTime.getSeconds()).slice(-2);
        const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        return formattedDateTime;
    }
}
